import React from 'react';

function PrivacyPolicy() {
  return (
    <div className="container mx-auto py-12">
      <h2 className="text-3xl font-semibold text-center mb-6">Privacy Policy</h2>
      <p className="text-lg text-gray-700 mb-6">
        At Not Ashamed of the Gospel Ministry (NAOGM), we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard your personal information.
      </p>
      <h3 className="text-xl font-semibold mb-4">Information We Collect</h3>
      <p className="text-gray-700 mb-4">
        We may collect personal information such as your name, email, and donation details when you interact with our website or submit forms.
      </p>
      <h3 className="text-xl font-semibold mb-4">How We Use Your Information</h3>
      <p className="text-gray-700 mb-4">
        Your information is used to process donations, respond to inquiries, and send updates about NAOGM’s activities.
      </p>
      <p className="text-gray-700">
        For full details, contact us at info@naogm.org.
      </p>
    </div>
  );
}

export default PrivacyPolicy;